import { buildWabunkaExperienceListViewModel, type WabunkaExperienceViewModel } from '@/models/wabunka/wabunkaExperience';

import type { WabunkaExperienceSection, WabunkaExperienceSectionListResponse } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_section';
import type { WabunkaWebPage } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_web_page';
/**
 * Wabunka 体験セクションビューモデル
 */
export interface ExperienceSectionViewModel {
  /** ID */
  id: string;
  /** タイトル */
  title: string;
  /** webセクションID */
  webSectionId: string;
  /** リンク先Webパス */
  destinationWebPath: string;
  /** webページ情報 */
  webPages: WabunkaWebPage[];
  /** 体験セクションに属している体験 */
  experiences: WabunkaExperienceViewModel[];
  /** シーケンスID */
  sequenceId: number;
}

/**
 * 体験セクションビューモデル のデフォルト値を返却する
 *
 * @returns {ExperienceSectionViewModel} - 体験セクションビューモデル のデフォルト値
 */
export const createDefaultExperienceSectionViewModel = (): ExperienceSectionViewModel => ({
  id: '',
  title: '',
  webSectionId: '',
  destinationWebPath: '',
  webPages: [],
  experiences: [],
  sequenceId: 0,
});

/**
 * APIレスポンスからビューモデルを作成する
 *
 * @param {WabunkaExperienceSection} res - APIレスポンス
 * @returns {WabunkaExperienceSectionViewModel} - ビューモデル
 */
export const buildExperienceSectionViewModel = (res: WabunkaExperienceSection | undefined): ExperienceSectionViewModel => {
  if (!res) return createDefaultExperienceSectionViewModel();
  return {
    id: res.id,
    title: res.title,
    webSectionId: res.webSectionId,
    destinationWebPath: res.destinationWebPath,
    webPages: res.webPages,
    experiences: buildWabunkaExperienceListViewModel(res.experiences),
    sequenceId: res.sequenceId,
  };
};

/**
 * リスト表示用のビューモデル
 */
export type ExperienceSectionListViewModel = ExperienceSectionViewModel[];

/**
 * リスト表示用のビューモデルを組み立てる
 *
 * @param {WabunkaExperienceSectionListResponse} res - APIレスポンス
 * @returns {ExperienceSectionListViewModel} - ビューモデル
 */
export const buildExperienceSectionListViewModel = (res: WabunkaExperienceSectionListResponse | null): ExperienceSectionListViewModel => {
  if (!res || !res.items) {
    return [];
  }

  return res.items.map(buildExperienceSectionViewModel);
};
